import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container_provider/show_process/${agro_exporter_id}/agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchGraphicsData(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_reports/container_provider/show_process/${agro_exporter_id}/fetch_graphics_data/${agro_exporter_process_id}`
    );
  },
};
